import { State } from '../reducers/email-template.reducers';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EmailTemplateModel } from '../models/email-template-model';

export const selectEmailTemplatesState = createFeatureSelector<State>('emailTemplates');

export const selectLoading = createSelector(
  [selectEmailTemplatesState],
  (s: State) => {
    return s.loading;
  }
);

const selectTemplates = createSelector(
  [selectEmailTemplatesState],
  (s: State) => {
    return s.emailTemplates || [];
  }
);

export const selectCustomTemplates = createSelector(
  [selectTemplates],
  (allTemplates: EmailTemplateModel[]) => {
    return allTemplates.filter( emt => !emt.isDefault );
  }
);

export const selectDefaultTemplates = createSelector(
  [selectTemplates],
  (allTemplates: EmailTemplateModel[]) => {
    return allTemplates.filter(emt => emt.isDefault);
  }
);


export const getDefaultForTemplate =
  (template: EmailTemplateModel, defaults: EmailTemplateModel[]) => defaults.find(
    c => c.productId === template.productId && c.name === template.name);

export const selectorDefaultForTemplate = (template: EmailTemplateModel) => {
  return createSelector([selectDefaultTemplates], (defaults) => getDefaultForTemplate(template, defaults));
}

export const consolidateTemplates = (defaults: EmailTemplateModel[], customs: EmailTemplateModel[]) => defaults.map(d => customs.find(c => c.productId === d.productId && c.name === d.name) || d);

/**
 * All templates except any custom templates are used for product/template name over default templates with same product/template name
 */
export const selectConsolidatedTemplates = createSelector([selectDefaultTemplates, selectCustomTemplates], consolidateTemplates);


/*
 * 
export const selectLoading = createSelector(
  [selectEmailTemplate],
  (state: State) => state.loading
)
*/
